import { StopAPI } from '../../../api/bussched/StopAPI';

export class StopsCommand {
    list(edition, successCallback, errorCallback) {
        const apiResult = StopAPI.list(edition);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu um erro a ler as Paragens da Linha selecionada");
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/bussched/commands/StopsCommand.js